/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const InputHintText: React.FC<{ style?: any; }> = (props) => (
  <div className="font-caption-1 font-color-gsMedDark" style={{ marginTop: 4, minHeight: 16, ...props.style }}>
    {props.children}
  </div>
);

export default InputHintText;
